$(window).scroll(function () {
    $('#scroller')[$(this).scrollTop() > 0 ? 'fadeIn' : 'fadeOut']();
});

$('#scroller').click(function (ev) {
    ev.preventDefault();

    $('body,html').animate({scrollTop: 0}, 400);
});
